import { render, staticRenderFns } from "./QColorHueSlider.vue?vue&type=template&id=3061cd16&"
import script from "./QColorHueSlider.vue?vue&type=script&lang=js&"
export * from "./QColorHueSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports